import React, { useEffect, useRef, useState } from "react";
import { AfDataType } from "utils/TableColumnData";
import { GetCommanWay } from "API/commonApi";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";

import { saveAs } from "file-saver";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import Spinner from "utils/Spinner";
import Select from "react-select";

const FlightSearch: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [title, setTitle] = useState<any>("");

  const [fromCity, setFromCity] = useState<any>("");
  const [toCity, setToCity] = useState<any>("");

  const [selectedFromCity, setSelectedFromCity] = useState<any>({});
  const [selectedToCity, setSelectedToCity] = useState<any>({});
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));

  const [sortStat, setSortStat] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const { isFetching, refetch } = useQuery(
    ["flight_list"],
    () =>
      GetCommanWay(
        `/flight-route/${selectedFromCity?.value}/${selectedToCity?.value}/${moment(startDate).format("YYYY")}/${moment(startDate).format(
          "M"
        )}/${moment(startDate).format("D")}?carrierCode=&numHours=24&hour=0`,
        {},
        {}
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log(data?.data?.data);
          let tableData = [];
          data?.data?.data?.flights?.forEach((r) => {
            if (!r.operatedBy) {
              tableData.push({
                flight: r?.carrier.fs + " " + r.carrier.flightNumber,
                airline: r?.carrier.name,
                departure: r.departureTime.time24,
                arrival: r.arrivalTime.time24,
                link: r.url,
              });
            }
          });
          console.log(tableData);
          setTableData(tableData);
          setTitle(data?.data?.data?.header?.title || "");
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  const __handleSubmit = async () => {
    refetch();
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      {isFetching && <Spinner />}
      <h1 className="text-center mb-2 mt-1 text-lg font-semibold ">
        Flight Schedule --- <u>{title}</u>
      </h1>
      <div className="px-4 border-[1px] py-2  rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-x-4 gap-y-2">
            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">From Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                placeholder="Start Date"
                name="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">Departure</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={airportCodes}
                onChange={(e) => {
                  setSelectedFromCity(e);
                }}
                value={selectedFromCity}
              />
            </div>
            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">Arrival</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={airportCodes}
                onChange={(e) => {
                  setSelectedToCity(e);
                }}
                value={selectedToCity}
              />
            </div>

            <button
              type="button"
              onClick={__handleSubmit}
              className="ml-2 mt-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <div className="px-4">
        <table className="w-full table- mb-8 text-xl" id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr>
              <th className="border border-slate-200 px-1">Sr.</th>
              <th className="border border-slate-200 px-1">Flight {GET_SORT_ICON("flight", "")}</th>
              <th className="border border-slate-200 px-1">Airline {GET_SORT_ICON("airline", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Departure {GET_SORT_ICON("departure", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Arrival {GET_SORT_ICON("arrival", "")}</th>
              <th className="border border-slate-200 px-1">Action</th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                return (
                  <tr key={"flight-" + i} className={`${i % 2 == 0 ? "bg-blue-400" : "bg-blue-200"}`}>
                    <td className="border border-slate-200 px-2 py-0.5">{i + 1}</td>
                    <td className="border border-slate-200 px-2 py-0.5">{r.flight}</td>
                    <td className="border border-slate-200 px-2 py-0.5">{r.airline}</td>
                    <td className="border border-slate-200 px-2 py-0.5">{r.departure}</td>
                    <td className="border border-slate-200 px-2 py-0.5">{r.arrival}</td>
                    <td className="border border-slate-200 px-2 py-0.5">
                      <a href={`https://www.flightstats.com/v2${r.link}`} target="_blank">
                        Check Info
                      </a>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default FlightSearch;
const airportCodes = [
  { label: "Agra - AGR", name: "Agra", value: "AGR" },
  { label: "Agatti Island - AGX", name: "Agatti Island", value: "AGX" },
  { label: "Aizawl - AJL", name: "Aizawl", value: "AJL" },
  { label: "Agartala - IXA", name: "Agartala", value: "IXA" },
  { label: "Ahmedabad - AMD", name: "Ahmedabad", value: "AMD" },
  { label: "Amritsar - ATQ", name: "Amritsar", value: "ATQ" },
  { label: "Aurangabad - IXU", name: "Aurangabad", value: "IXU" },
  { label: "Ayodhya - AYJ", name: "Ayodhya", value: "AYJ" },
  { label: "Bagdogra - IXB", name: "Bagdogra", value: "IXB" },
  { label: "Bareilly - BEK", name: "Bareilly", value: "BEK" },
  { label: "Belgaum - IXG", name: "Belgaum", value: "IXG" },
  { label: "Bangalore - BLR", name: "Bangalore", value: "BLR" },
  { label: "Bhopal - BHO", name: "Bhopal", value: "BHO" },
  { label: "Bhubaneswar - BBI", name: "Bhubaneswar", value: "BBI" },
  { label: "Chandigarh - IXC", name: "Chandigarh", value: "IXC" },
  { label: "Chennai - MAA", name: "Chennai", value: "MAA" },
  { label: "Coimbatore - CJB", name: "Coimbatore", value: "CJB" },
  { label: "Darbhanga - DBR", name: "Darbhanga", value: "DBR" },
  { label: "Dehradun - DED", name: "Dehradun", value: "DED" },
  { label: "Delhi - DEL", name: "Delhi", value: "DEL" },
  { label: "Deoghar - DGH", name: "Deoghar", value: "DGH" },
  { label: "Dharamshala - DHM", name: "Dharamshala", value: "DHM" },
  { label: "Dibrugarh - DIB", name: "Dibrugarh", value: "DIB" },
  { label: "Dimapur - DMU", name: "Dimapur", value: "DMU" },
  { label: "Diu - DIU", name: "Diu", value: "DIU" },
  { label: "Andal - RDP", name: "Andal", value: "RDP" },
  { label: "Gaya - GAY", name: "Gaya", value: "GAY" },
  { label: "Goa - GOI", name: "Goa", value: "GOI" },
  { label: "Gondia - GDB", name: "Gondia", value: "GDB" },
  { label: "Gorakhpur - GOP", name: "Gorakhpur", value: "GOP" },
  { label: "Guwahati - GAU", name: "Guwahati", value: "GAU" },
  { label: "Gwalior - GWL", name: "Gwalior", value: "GWL" },
  { label: "Hubli - HBX", name: "Hubli", value: "HBX" },
  { label: "Hyderabad - HYD", name: "Hyderabad", value: "HYD" },
  { label: "Imphal - IMF", name: "Imphal", value: "IMF" },
  { label: "Indore - IDR", name: "Indore", value: "IDR" },
  { label: "Jabalpur - JLR", name: "Jabalpur", value: "JLR" },
  { label: "Jagdalpur - JGB", name: "Jagdalpur", value: "JGB" },
  { label: "Jaipur - JAI", name: "Jaipur", value: "JAI" },
  { label: "Jaisalmer - JSA", name: "Jaisalmer", value: "JSA" },
  { label: "Jammu - IXJ", name: "Jammu", value: "IXJ" },
  { label: "Jharsuguda - JRG", name: "Jharsuguda", value: "JRG" },
  { label: "Jodhpur - JDH", name: "Jodhpur", value: "JDH" },
  { label: "Jorhat - JRH", name: "Jorhat", value: "JRH" },
  { label: "Cuddapah - CDP", name: "Cuddapah", value: "CDP" },
  { label: "Kannur - CNN", name: "Kannur", value: "CNN" },
  { label: "Kanpur - KNU", name: "Kanpur", value: "KNU" },
  { label: "Khajuraho - HJR", name: "Khajuraho", value: "HJR" },
  { label: "Kochi - COK", name: "Kochi", value: "COK" },
  { label: "Kolhapur - KLH", name: "Kolhapur", value: "KLH" },
  { label: "Kolkata - CCU", name: "Kolkata", value: "CCU" },
  { label: "Kozhikode - CCJ", name: "Kozhikode", value: "CCJ" },
  { label: "Kurnool - KJB", name: "Kurnool", value: "KJB" },
  { label: "Leh - IXL", name: "Leh", value: "IXL" },
  { label: "Lucknow - LKO", name: "Lucknow", value: "LKO" },
  { label: "Madurai - IXM", name: "Madurai", value: "IXM" },
  { label: "Mangalore - IXE", name: "Mangalore", value: "IXE" },
  { label: "Mumbai - BOM", name: "Mumbai", value: "BOM" },
  { label: "Mysore - MYQ", name: "Mysore", value: "MYQ" },
  { label: "Nagpur - NAG", name: "Nagpur", value: "NAG" },
  { label: "Nashik - ISK", name: "Nashik", value: "ISK" },
  { label: "Nainital - PGH", name: "Nainital", value: "PGH" },
  { label: "Patna - PAT", name: "Patna", value: "PAT" },
  { label: "Port Blair - IXZ", name: "Port Blair", value: "IXZ" },
  { label: "Allahabad - IXD", name: "Allahabad", value: "IXD" },
  { label: "Pune - PNQ", name: "Pune", value: "PNQ" },
  { label: "Raipur - RPR", name: "Raipur", value: "RPR" },
  { label: "Rajahmundry - RJA", name: "Rajahmundry", value: "RJA" },
  { label: "Rajkot - RAJ", name: "Rajkot", value: "RAJ" },
  { label: "Ranchi - IXR", name: "Ranchi", value: "IXR" },
  { label: "Salem - SXV", name: "Salem", value: "SXV" },
  { label: "Shillong - SHL", name: "Shillong", value: "SHL" },
  { label: "Silchar - IXS", name: "Silchar", value: "IXS" },
  { label: "Srinagar - SXR", name: "Srinagar", value: "SXR" },
  { label: "Surat - STV", name: "Surat", value: "STV" },
  { label: "Trivandrum - TRV", name: "Trivandrum", value: "TRV" },
  { label: "Tiruchirappalli - TRZ", name: "Tiruchirappalli", value: "TRZ" },
  { label: "Tirupati - TIR", name: "Tirupati", value: "TIR" },
  { label: "Thoothukudi - TCR", name: "Thoothukudi", value: "TCR" },
  { label: "Udaipur - UDR", name: "Udaipur", value: "UDR" },
  { label: "Vadodara - BDQ", name: "Vadodara", value: "BDQ" },
  { label: "Varanasi - VNS", name: "Varanasi", value: "VNS" },
  { label: "Vijayawada - VGA", name: "Vijayawada", value: "VGA" },
  { label: "Visakhapatnam - VTZ", name: "Visakhapatnam", value: "VTZ" },
  { label: "Akola - AKD", name: "Akola", value: "AKD" },
  { label: "Along - IXV", name: "Along", value: "IXV" },
  { label: "Bhuj - BHJ", name: "Bhuj", value: "BHJ" },
  { label: "Bhavnagar - BHU", name: "Bhavnagar", value: "BHU" },
  { label: "Bhatinda - BUP", name: "Bhatinda", value: "BUP" },
  { label: "Bellary - BEP", name: "Bellary", value: "BEP" },
  { label: "Bidar - IXX", name: "Bidar", value: "IXX" },
  { label: "Bikaner - BKB", name: "Bikaner", value: "BKB" },
  { label: "Bilaspur - PAB", name: "Bilaspur", value: "PAB" },
  { label: "Car Nicobar - CBD", name: "Car Nicobar", value: "CBD" },
  { label: "Cooch Behar - COH", name: "Cooch Behar", value: "COH" },
  { label: "Daman - NMB", name: "Daman", value: "NMB" },
  { label: "Daporijo - DAE", name: "Daporijo", value: "DAE" },
  { label: "Deparizo - DEP", name: "Deparizo", value: "DEP" },
  { label: "Dhanbad - DBD", name: "Dhanbad", value: "DBD" },
  { label: "Hindon - VDX", name: "Hindon", value: "VDX" },
  { label: "Gulbarga - GBI", name: "Gulbarga", value: "GBI" },
  { label: "Guna - GUX", name: "Guna", value: "GUX" },
  { label: "Hissar - HSS", name: "Hissar", value: "HSS" },
  { label: "Jamshedpur - IXW", name: "Jamshedpur", value: "IXW" },
  { label: "Jamnagar - JGA", name: "Jamnagar", value: "JGA" },
  { label: "Jalgaon - JLG", name: "Jalgaon", value: "JLG" },
  { label: "Jeypore - PYB", name: "Jeypore", value: "PYB" },
  { label: "Kailashahar - IXH", name: "Kailashahar", value: "IXH" },
  { label: "Kamalpur - IXQ", name: "Kamalpur", value: "IXQ" },
  { label: "Keshod - IXK", name: "Keshod", value: "IXK" },
  { label: "Khed - OMN", name: "Khed", value: "OMN" },
  { label: "Khowai - IXN", name: "Khowai", value: "IXN" },
  { label: "Kishangarh - KQH", name: "Kishangarh", value: "KQH" },
  { label: "Kota - KTU", name: "Kota", value: "KTU" },
  { label: "Kandla - IXY", name: "Kandla", value: "IXY" },
  { label: "Kullu - KUU", name: "Kullu", value: "KUU" },
  { label: "Lilabari - IXI", name: "Lilabari", value: "IXI" },
  { label: "Ludhiana - LUH", name: "Ludhiana", value: "LUH" },
  { label: "Latur - LTU", name: "Latur", value: "LTU" },
  { label: "Malda - LDA", name: "Malda", value: "LDA" },
  { label: "Muzaffarpur - MZU", name: "Muzaffarpur", value: "MZU" },
  { label: "Nanded - NDC", name: "Nanded", value: "NDC" },
  { label: "Neyveli - NVY", name: "Neyveli", value: "NVY" },
  { label: "Porbandar - PBD", name: "Porbandar", value: "PBD" },
  { label: "Pondicherry - PNY", name: "Pondicherry", value: "PNY" },
  { label: "Pakyong - PYG", name: "Pakyong", value: "PYG" },
  { label: "Pasighat - IXT", name: "Pasighat", value: "IXT" },
  { label: "Puttaparthi - PUT", name: "Puttaparthi", value: "PUT" },
  { label: "Pathankot - IXP", name: "Pathankot", value: "IXP" },
  { label: "Rupsi - RUP", name: "Rupsi", value: "RUP" },
  { label: "Ramagundam - RMD", name: "Ramagundam", value: "RMD" },
  { label: "Ratnagiri - RTC", name: "Ratnagiri", value: "RTC" },
  { label: "Rewa - REW", name: "Rewa", value: "REW" },
  { label: "Rourkela - RRK", name: "Rourkela", value: "RRK" },
  { label: "Shimla - SLV", name: "Shimla", value: "SLV" },
  { label: "Satna - TNI", name: "Satna", value: "TNI" },
  { label: "Solapur - SSE", name: "Solapur", value: "SSE" },
  { label: "Tezpur - TEZ", name: "Tezpur", value: "TEZ" },
  { label: "Tanjore - TJV", name: "Tanjore", value: "TJV" },
  { label: "Tezu - TEI", name: "Tezu", value: "TEI" },
  { label: "Toranagallu - VDY", name: "Toranagallu", value: "VDY" },
  { label: "Warangal - WGC", name: "Warangal", value: "WGC" },
  { label: "Zero - ZER", name: "Zero", value: "ZER" },
];
